import BonusList from './BonusList';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';

export default {
  list: BonusList,
  icon: DirectionsCarIcon,
};